import { render, staticRenderFns } from "./about.vue?vue&type=template&id=3e560462&scoped=true&"
var script = {}
import style0 from "./about.vue?vue&type=style&index=0&id=3e560462&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e560462",
  null
  
)

export default component.exports